import Wrapper from '@app/Wrapper.js'
import App from './App.vue'

Munio.AccessZoneOverview = class extends Wrapper {
  component() {
    return App
  }
}
